module.exports = __webpack_public_path__ + "assets/assets/images/about/financial.15a2d78b.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/about/financial.png
// module id = 547
// module chunks = 0